<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtitle">foreword</h2>
<p class="abstract"><i>“Let food be thy medicine, and let medicine be thy food.”</i></p>
<p class="chauthor">HIPPOCRATES</p>
<p class="common"><img alt="" src="images/common.jpg"/></p>
<p class="noindent">I have always believed that food is our greatest and most powerful medicine, just as Hippocrates once said. That is one of the reasons I was so intrigued when I first heard Dani Williamson’s story. I know that food was her greatest <i>enemy</i> her entire life until the <i>one</i> day when someone she trusted spoke the words that changed her life forever: “Dani, what have you been eating? Don’t you know that food determines your health?”</p>
<p class="noindent">I first met Dani over ten years ago when she worked at Cool Springs Family Medicine, in Franklin, Tennessee, where I’d stop by to drop off copies of my first book, <i>The Real Food Diet</i>. I’ve since watched her take the leap of faith and start her own now-thriving practice, Integrative Family Medicine, in Franklin.</p>
<p class="noindent">I have seen her passion and know she cares about not just <i>helping</i> people, but rather transforming them. That is precisely why, when I come across a complicated case (a person who other doctors keep reassuring, “Your labs are normal… you’ll be just fine” but they <i>know</i> they are not fine), I send them to Dani.</p>
<p class="noindent">She WAS that patient. She’s been on the receiving end of one careless diagnosis after another, and it wasn’t until she realized the power of food that her life was also transformed.</p>
<p class="noindent">Dani is the real deal, and I trust her approach because she works on healing from the inside-out. She is my go-to source for healing from many auto-immune diseases, and I’ve even brought her into Ancient Nutrition to do a lunch and learn on Hashimoto’s.</p>
<p class="noindent">Dani is as bold as her hair, and her fearlessness is unrivaled. Listen to her wisdom, learn from her mistakes, benefit from her knowledge, and reclaim the vitality and joy that you deserve! I pray that <i>Wild and Well</i> and its straightforward steps to transformational healing will change the trajectory of your life and your family’s lives.</p>
<p class="right">—Dr. Josh Axe, DNM, DC, CNS</p>
<p class="right">Author of <i>Ancient Remedies</i></p>
<div class="figure">
<p class="image"><img alt="" src="images/fig4.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm03.vue?4ec05c86